// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../../../../../../../../work/modules/node_modules/css-loader/dist/cjs.js??ref--4-oneOf-1-1!../../../../../../../../../../work/modules/node_modules/postcss-loader/dist/cjs.js??ref--4-oneOf-1-2!./floating-vue.css");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = require("!../../../../../../../../../../work/modules/node_modules/vue-style-loader/lib/addStylesClient.js").default
var update = add("8c8615f0", content, true, {"sourceMap":false});